// extracted by mini-css-extract-plugin
export default {"list":"list_list__u-ikR","dotted":"list_dotted__-qCEc list_list__u-ikR","checklist":"list_checklist__Q3jAZ list_list__u-ikR"};